import { Skills } from '../types';
import { escapeHtml } from '../utils/security';
import { sectionHeader } from './common';

export function buildSkills(skills: Skills) {
    const root = document.querySelector('[data-section="skills"]');
    if (!root) return;

    const groupsHtml = skills.groups.map(group => `
        <div class="bg-white border border-n100 rounded-lg p-6 shadow-sm">
            <div class="flex items-center gap-3 mb-[18px] pb-3.5 border-b border-n100">
                <i data-lucide="${escapeHtml(group.icon)}" stroke-width="1.5" class="w-[22px] h-[22px] text-sunset-dark"></i>
                <h3 class="text-base font-semibold text-graphite">${escapeHtml(group.category)}</h3>
            </div>
            <div class="flex flex-wrap gap-2">
                ${group.items.map(item => `
                    <span class="px-3 py-[5px] rounded-full text-[13px] font-medium bg-creme text-n500 border border-n100 inline-block">${escapeHtml(item)}</span>
                `).join('')}
            </div>
        </div>
    `).join('');

    const itemsHtml = skills.items.map(item => `
        <div class="bg-white border border-n100 rounded-lg p-6 shadow-sm">
            <div class="w-[46px] h-[46px] rounded-md bg-graphite flex items-center justify-center text-sunset mb-[18px]">
                <i data-lucide="${escapeHtml(item.icon)}" stroke-width="1.5" class="w-[22px] h-[22px]"></i>
            </div>
            <h4 class="text-base font-semibold text-graphite mb-2.5">${escapeHtml(item.title)}</h4>
            <p class="text-sm leading-relaxed text-n500">${escapeHtml(item.stack)}</p>
        </div>
    `).join('');

    root.innerHTML = `
        ${sectionHeader(skills.kicker, skills.heading)}

        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mb-5 animate-fadeUp">
            ${groupsHtml}
        </div>

        <div class="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 animate-fadeUp" style="animation-delay: 0.1s">
            ${itemsHtml}
        </div>
    `;
}
